import './ViewContainer.scss';

import React from 'react';
import { useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import { useIsEmbedded } from 'hooks/useIsEmbedded';

import {
  getCurrentUserId,
  getCurrentUserIsManagerial,
} from 'selectors/session';

import { cxHelpers } from 'util/className';

const { cx, cxEl } = cxHelpers('ViewContainer');

type Props = {
  children: React.ReactNode;
};

const ViewContainer = ({ children }: Props) => {
  const isEmbedded = useIsEmbedded();
  const isManagerial = useSelector(getCurrentUserIsManagerial);
  const isLoggedIn = !!useSelector(getCurrentUserId);

  return (
    <div
      className={cx({
        isEmbedded,
        employeeView: !isManagerial && isLoggedIn,
      })}
    >
      <Box className={cxEl('inner')} bgcolor={isEmbedded ? 'mono0' : 'mono100'}>
        {children}
      </Box>
    </div>
  );
};

export default ViewContainer;
